import { Info } from "@/public/icons/info";
import { Alert as MuiAlert, AlertTitle as MuiAlertTitle } from "@mui/material";
import { isMobile } from "react-device-detect";
import cn from "clsx";

export function Alert(props: any) {
  const { title, description, children, icon, style, ...restProps } = props;
  return (
    <MuiAlert
      {...restProps}
      icon={icon === true && !isMobile ? <Info /> : false}
      sx={{
        "box-shadow": "0px 1px 6px 0px rgba(0, 0, 0, 0.12)",
        background: "#009DDE0F",
        ".MuiAlert-icon	": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "5px",
        },
        ".MuiAlert-message": {
          color: "#545C68",
          fontSize: "15px",
          lineHeight: "22px",
        },
        ...style,
      }}
    >
      {title && <MuiAlertTitle className={cn({
          "m-0": !description && !children,
      })}>{title}</MuiAlertTitle>}
      {description}
      {children}
    </MuiAlert>
  );
}
